import { Injectable } from "@angular/core";
import { CellDataType } from "@models/grid/cell-data-type.enum";
import { FilterOption } from "@models/grid/grid-filter";
import { UserPermissionsFilterOptions, UserStatus } from "@models/organisations/user-record";
import {
  AgUserRolesComponent
} from "@pages/settings/components/users-and-permissions-page/components/ag-user-permissions/ag-user-roles.component";
import {
  AgUserStatusComponent
} from "@pages/settings/components/users-and-permissions-page/components/ag-user-status/ag-user-status.component";
import { AgDateCellComponent } from "@shared/components/grid/ag-cells/common/ag-date-cell/ag-date-cell.component";
import {
  AgPhoneNumberComponent
} from "@shared/components/grid/ag-cells/common/ag-phone-number/ag-phone-number.component";
import { BaseGridService } from "@shared/services/base/base-grid.service";
import { convertEnumToFilterOption } from "@shared/utils/enum-to-filter-option.helper";
import { ColDef } from "ag-grid-community";

@Injectable()
export class UsersAndPermissionsGridService extends BaseGridService {

  // filters
  dateCreatedFilterOptions: FilterOption[] = [];
  twoFaFilterOptions: FilterOption[] = [];
  lastLoginFilterOptions: FilterOption[] = [];

  setFiltersOptions(
    dateCreatedFilterOptions: FilterOption[],
    twoFaFilterOptions: FilterOption[],
    lastLoginFilterOptions: FilterOption[]
  ): void {
    this.dateCreatedFilterOptions = dateCreatedFilterOptions;
    this.twoFaFilterOptions = twoFaFilterOptions;
    this.lastLoginFilterOptions = lastLoginFilterOptions;
  }

  override setColDefs(actionColumn: ColDef) {
    const colDefs: ColDef[] = [
      {
        headerName: 'User Name',
        field: 'fullName',
        flex: 2,
        editable: false,
      },
      {
        headerName: 'Email',
        field: 'email',
        flex: 2,
      },
      {
        headerName: 'Mobile Number',
        field: 'phoneNumber',
        cellRenderer: AgPhoneNumberComponent,
        flex: 2,
      },
      {
        headerName: 'Access Permissions',
        field: 'roles',
        flex: 1,
        cellRenderer: AgUserRolesComponent,
        filter: 'agSetColumnFilter',
        filterParams: {
          filterOptions: UserPermissionsFilterOptions
        },
      },
      {
        headerName: 'Last Login',
        field: 'lastLogin',
        cellRenderer: AgDateCellComponent,
        cellDataType: CellDataType.DATE_STRING,
        filter: 'agSetColumnFilter',
        filterParams: {
          filterOptions: this.lastLoginFilterOptions
        },
        hide: true,
      },
      {
        headerName: 'Status',
        field: 'status',
        cellRenderer: AgUserStatusComponent,
        filter: 'agSetColumnFilter',
        filterParams: {
          filterOptions: convertEnumToFilterOption(UserStatus)
        },
        hide: true,
      },
      {
        headerName: '2FA Method',
        field: 'twoFa',
        valueGetter: () => '2FA Method',
        filter: 'agSetColumnFilter',
        filterParams: {
          filterOptions: this.twoFaFilterOptions
        },
        hide: true,
      },
      {
        headerName: 'Date Created',
        field: 'dateCreated',
        cellRenderer: AgDateCellComponent,
        cellDataType: CellDataType.DATE_STRING,
        filter: 'agSetColumnFilter',
        filterParams: {
          filterOptions: this.dateCreatedFilterOptions
        },
        hide: true,
      },
      actionColumn,
    ]
      .map((colDef) => ({ ...colDef, suppressHeaderMenuButton: true } as ColDef));

    this.colDefs.set(colDefs);
  }
}
